export function toEdgeStyle() {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
}

export function bottomLeftStyle() {
  return {
    position: 'absolute',
    left: 0,
    bottom: 0
  };
}

export function rightStyle() {
  return {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0
  };
}

export function centerStyle() {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
}

export function fontStyle() {
  return {
    fontFamily: 'Roboto',
    WebkitFontSmoothing: 'antialiased'
  };
}

export default {
  toEdgeStyle: toEdgeStyle(),
  bottomLeftStyle: bottomLeftStyle(),
  rightStyle: rightStyle(),
  centerStyle: centerStyle(),
  fontStyle: fontStyle()
};



// WEBPACK FOOTER //
// ./src/styles/index.js